import { enumerate } from 'utils/strActions';
import styles from './MinorAgeChecker.module.scss';
import { ReactComponent as AlertIcon } from './img/alert.svg';

interface MinorAgeCheckerProps {
  data: any;
  showLabel: boolean;
}

export default function MinorAgeChecker({ data, showLabel }: MinorAgeCheckerProps) {
  const birthDate = new Date(data?.worker_app?.birthdate);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  const reformattedAge = String(data?.worker_app?.birthdate)
    .split('-')
    .reverse()
    .join('.');

  return (
    <>
      {age < 18 ? (
        <div className={styles.statusBlock}>
          {showLabel ? <span className={styles.label}>Возраст исполнителя</span> : null}
          <span className={styles.statusItemSvg}>
            <AlertIcon width={showLabel ? 18 : 24} height={showLabel ? 18 : 24} />{' '}
            {reformattedAge} {`(${age} ${enumerate(age, ['год', 'года', 'лет'])})`} -
            несовершеннолетний
          </span>
        </div>
      ) : null}
    </>
  );
}
